import React, { useEffect, useState } from "react";
import LoadingModal from "src/components/molecules/loading/LoadingModal";
import { confirmationCode } from "../auth";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonPro from "src/components/atoms/primary-button/primary-button";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";
import Logo from "src/components/molecules/logo/Logo";
import OTPInput from "src/components/molecules/otp-input/otp-input";
import { EnvelopeIcon } from "@heroicons/react/24/solid";
import LogoutLinkButton from "src/components/molecules/logout-button/logout-link-button";
import Modal from "src/components/molecules/modal/modal";

const ConfirmPassword: React.FC = () => {
	const location = useLocation();
	const email = location.state?.businessEmail;
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const [authCode, setAuthCode] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmNewPassword, setConfirmNewPassword] = useState("");
	const [passwordUpdated, setPasswordUpdated] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (!email) {
			navigate("/login");
		}
	}, [email, navigate]);

	const handleVerifyCodeSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		console.log(`in..`);
		setError("");
		// Ensure passwords match before proceeding
		if (newPassword !== confirmNewPassword) {
			console.log(`Passwords do not match!`);
			setError("Passwords do not match!");
			return;
		}
		setLoading(true);
		setError(""); // Clear error if passwords match
		console.log("Auth Code Submitted:", authCode);
		confirmationCode(email, authCode, newPassword, (err) => {
			setLoading(false);
			if (err) {
				console.error(`error ${err.message}`);
				setError(err.message || JSON.stringify(err));
			} else {
				setPasswordUpdated(true);
			}
		});
	};

	return (
		<>
			<div className="md:bg-app-gradient flex flex-col items-center justify-start md:justify-center h-screen w-screen md:py-8">
				<div className="bg-white text-gray-900 flex flex-col gap-6 items-center justify-start md:justify-center h-full md:h-fit w-full md:w-fit p-12 md:rounded-2xl md:shadow-[0_30px_50px_rgba(0,0,0,.5)] border border-white/20">
					<Logo></Logo>
					<span className="font-Poppins tracking-wider bg-gradient-to-bl from-purple-600 to-red-800 text-4xl md:text-6xl font-bold lg:text-4xl bg-clip-text text-transparent drop-shadow-2xl text-center">
						Reset your password?
					</span>

					<label className="ms-2 text-md font-semibold">
						Don&apos;t have a secured calls account?{" "}
						<a
							href="/signup"
							className="text-blue-600 dark:text-blue-500 hover:underline"
						>
							Sign-up here.
						</a>
					</label>
					{email && (
						<div className="flex flex-col items-center gap-2 font-Poppins tracking-wider py-2 px-4 text-gray-800 font-semibold w-fit">
							<EnvelopeIcon className="w-6 h-6 text-gray-900"></EnvelopeIcon>
							{email}
						</div>
					)}
					<form
						className="flex flex-col items-center justify-center gap-6 w-full"
						onSubmit={handleVerifyCodeSubmit}
					>
						<span className="ms-2 text-md font-semibold">
							Authorisation code
						</span>
						<OTPInput
							numDigits={6}
							onComplete={function (otp: string): void {
								setAuthCode(otp);
							}}
						></OTPInput>

						<InputBox
							value={newPassword}
							label={"New password"}
							type={"password"}
							onChange={function (value: string): void {
								setNewPassword(value);
							}}
						></InputBox>
						<InputBox
							value={confirmNewPassword}
							label={"Confirm new password"}
							type={"password"}
							onChange={function (value: string): void {
								setConfirmNewPassword(value);
							}}
						></InputBox>
						<span className="text-red-500 font-semibold">
							{error}
						</span>
						<ButtonPro
							label={"Update password"}
							type="submit"
						></ButtonPro>
					</form>
					<LogoutLinkButton></LogoutLinkButton>
					<LoadingModal open={loading} message="Please wait..." />
				</div>

				<Modal
					isOpen={passwordUpdated}
					onClose={function (): void {
						navigate("/login");
					}}
				>
					<Logo size={48}></Logo>
					<span className="font-Poppins font-semibold">
						Your password has been updated successfully. Click “OK”
						to log in with your new password.
					</span>
				</Modal>
			</div>
		</>
	);
};

export default ConfirmPassword;
